module.exports = __webpack_public_path__ + "static/media/brownPants.5dbd9792.jpg";